import React from 'react'
import Dotdotdot from 'react-dotdotdot'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import KibTag from '@chewy/kib-tag-react'
import { Grid, Stack, TableCell } from '@mui/material'
import classNames from 'classnames'
import { type Nil, PermissionArea } from '@pbt/pbt-ui-components'
import HtmlContentRenderer from '@pbt/pbt-ui-components/src/components/HtmlContentRenderer'

import Link from '~/components/common/link/Link'
import { BaseRoute } from '~/constants/routes'
import { getCRUDByArea } from '~/store/reducers/auth'
import { replaceHtmlPairedTagWithAnother } from '~/utils'

import styles from './SubjectCell.module.scss'

const SubjectCell = ({
  subject,
  message,
  isDraft = false,
  isUnread = false,
  id,
}: {
  id: string
  isDraft?: boolean
  isUnread?: boolean
  message: string
  subject: string | Nil
}) => {
  const { t } = useTranslation(['Common'])
  const { read: communicationReadPermissions } = useSelector(
    getCRUDByArea(PermissionArea.COMMUNICATION),
  )
  const messagePreview = replaceHtmlPairedTagWithAnother(message, 'pre', 'div')
  const SubjectComponent = (
    <Dotdotdot
      clamp={1}
      className={classNames(styles.subject, {
        [styles.unread]: isUnread,
        [styles.includeLink]: communicationReadPermissions,
      })}
    >
      {subject}
    </Dotdotdot>
  )

  return (
    <TableCell>
      <Grid>
        {communicationReadPermissions ? (
          <Link to={`${BaseRoute.COMMUNICATIONS}/${id}`}>
            {SubjectComponent}
          </Link>
        ) : (
          SubjectComponent
        )}
        <Stack data-testid="message-preview" direction="row">
          {isDraft && <KibTag>{t('Common:DRAFT')}</KibTag>}
          <Dotdotdot clamp={1}>
            <HtmlContentRenderer
              className={styles.messagePreview}
              content={messagePreview}
            />
          </Dotdotdot>
        </Stack>
      </Grid>
    </TableCell>
  )
}

export default SubjectCell
